import MindupLogo from 'assets/Icons/Logo/MindupLogo';
import _ from 'lodash';
import { ChangeEvent, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import MobileCopyright from 'components/Common/MobileCopyright';
import { InputWithLabel } from 'components/Input/InputWithLabel';
import { useLoadingStore } from 'store/useLoadingStore';
import { loginValidate } from 'utils/validationFunctions';
import { useLoginApiHooks } from 'hooks/CustomHooks/APIHooks/useLoginApiHooks';
import { useLoginStore } from 'store/useLoginDataStore';
import { commonText, palceholderText } from 'constants/commonConstants';
import useToggle from 'hooks/CustomHooks/useToggle';
import BasicButton from 'components/Buttons/BasicButton';

const MindUpAdminMobileLogin = () => {
    const navigate = useNavigate();

    const initValue = { email: '', password: '' };

    const [value, setValue] = useState(initValue);
    const [errMsg, setErrMsg] = useState(initValue);

    const emailRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    const loginApiCall = useLoginApiHooks();

    const { setLoading } = useLoadingStore();
    const { loginData, setLoginData } = useLoginStore();

    const [isPasswordVisible, setIsPasswordVisible] = useToggle();

    // input change function
    const handleChange = (e: ChangeEvent<HTMLInputElement>, id: string) => {
        setValue({ ...value, [id]: e.target.value });

        if (id === 'password') {
            setErrMsg((prevErrMsg) => ({ ...prevErrMsg, [id]: '' }));
        } else {
            const error = loginValidate[id](e.target.value, id === 'password' ? value : '');
            setErrMsg((prevErrMsg) => ({ ...prevErrMsg, [id]: error }));
        }
    };

    // 로그인 버튼 클릭 function
    const handleClickLogin = async () => {
        setLoading(true);
        const emailError = loginValidate.email(value.email);
        const passwordError = loginValidate.password(value.password);
        if (emailError) {
            setErrMsg((prevErrMsg) => ({ ...prevErrMsg, email: emailError }));
            emailRef.current?.focus();
            setLoading(false);
        }

        if (passwordError) {
            setErrMsg((prevErrMsg) => ({ ...prevErrMsg, password: passwordError }));
            passwordRef.current?.focus();
            setLoading(false);
        }

        if (!emailError && !passwordError) {
            try {
                // account status Status 0번 ->  panding상태, Status 1번 -> 허가받은 상태, Status -1번 -> 거절된 상태
                await loginApiCall(value, setLoginData, setErrMsg, navigate, setLoading, emailRef, passwordRef);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const enterKey = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleClickLogin();
        }
    };

    return (
        <Layout>
            <Container>
                <MindupLogo />
                <InputAndButtonContainer>
                    <InputWrapper>
                        <InputWithLabel
                            ref={emailRef}
                            label={commonText.emailId}
                            placeholder={palceholderText.emailInput}
                            onChange={handleChange}
                            id='email'
                            focus={true}
                            errorMsg={errMsg.email}
                            value={value.email}
                            enterKey={enterKey}
                        />
                        <InputWithLabel
                            ref={passwordRef}
                            label={commonText.password}
                            placeholder={commonText.password}
                            onChange={handleChange}
                            isPasswordVisible={isPasswordVisible}
                            setIsPasswordVisible={setIsPasswordVisible}
                            id='password'
                            focus={false}
                            errorMsg={errMsg.password}
                            value={value.password}
                            enterKey={enterKey}
                        />
                    </InputWrapper>
                    <BasicButton onClick={handleClickLogin} $type='fill'>
                        {commonText.login}
                    </BasicButton>
                </InputAndButtonContainer>
            </Container>
            <CopyrightNotice>
                <MobileCopyright />
            </CopyrightNotice>
        </Layout>
    );
};

export default MindUpAdminMobileLogin;

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 296px;
    height: 100%;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 28px;
`;

const InputAndButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    // height: 288px;
    gap: 36px;
`;

const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    // height: 196px;
    gap: 28px;
`;

const CopyrightNotice = styled.span`
    display: flex;
    justify-content: center;
    width: 100%;
    opacity: 0.5;
    height: 48px;
`;
